import React from "react"
import styled from "styled-components"
import { Button, Paragraph, Theme } from "@pga/pga-component-library"

import { redirectToMemberApplications } from "../../../lib/ptmApplicationsRedirect"
import { Title } from "../Prospect/PathBox/styles"

const Card = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  margin-bottom: 20px;
  padding: 1rem 1.25rem;
  background-color: white;
  border-left: 4px solid ${Theme.colors.primary};
`

const PathPanel = styled.section`
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;
  padding: 20px 1.5rem;
`

export const MEMBER_APPLY_CTA_LABEL = "Apply for Membership"

const ApplyAction = () => (
  <Button color="primary" onClick={redirectToMemberApplications}>
    {MEMBER_APPLY_CTA_LABEL}
  </Button>
)

/**
 * Takes the place of the Path to Membership widget on the prospect dashboard
 * for an authorized reciprocity candidate, who has no Associate or Affiliate
 * path to choose.
 */
export const MemberApplyPanel = () => (
  <PathPanel aria-label="Apply for Membership">
    <Title>Path to Membership</Title>
    <Paragraph fw="normal" className="mb-0">
      You are eligible to apply for PGA Membership.
    </Paragraph>
    <ApplyAction />
  </PathPanel>
)

const MemberApplyEntry = ({ show = false }) => {
  if (!show) {
    return null
  }

  return (
    <Card aria-label="Apply for Membership">
      <Paragraph fw="normal" className="mb-0">
        You are eligible to apply for PGA Membership.
      </Paragraph>
      <ApplyAction />
    </Card>
  )
}

export default MemberApplyEntry
